import React from "react";
const PatientContact = ({
  id,
  name,
  initials,
  email,
  phone,
  selected,
  handleCheckPatientContact,
}) => {
  return (
    <div className="checkbox-container my-2" style={{ position: "relative" }}>
      <div className="container pl-0">
        <div className="row text-left border-bottom pr-3">
          <div className="col-sm-6 col-md-6 col-6  ">
            <input
              type="checkbox"
              id={id}
              checked={selected}
              value={id}
              key={id}
              onChange={handleCheckPatientContact}
            />
            <label htmlFor={id} className="" data-letters={initials}>
              <span>{name}</span>
            </label>
          </div>
          <div className="col-sm-6 col-md-6 col-6  py-2 text-right">
            <span>{email ? email : phone}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientContact;
